import {ConfigProvider} from "antd";
import enUS from "antd/locale/en_US";
import Layout from "../Layout";
import React from "react";

export const FullLayout: React.FC = () => {
  return (
    <ConfigProvider
        locale={enUS}
        theme={{
          components: {
            Form: {
              itemMarginBottom: 12,
            },
          },
        }}    >
      <div id="mynjappeal">
        <Layout />
      </div>
    </ConfigProvider>
  )
}